let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1Aiz0")).then(() => parcelRequire('7QYfj'));